import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../components/PageMeta';
import { requestPasswordReset } from '../lib/passwordResetApi';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage(null);
    setErrorMessage(null);
    setIsSubmitting(true);

    try {
      const res = await requestPasswordReset(email.trim());

      if (res.status === 200) {
        setMessage(
          res.message || 'ご入力のメールアドレス宛に、パスワード再設定用のリンクをお送りしました。'
        );
        setIsCompleted(true);
        return;
      }

      setErrorMessage(res.message || '送信に失敗しました。時間をおいて再度お試しください。');
    } catch {
      setErrorMessage('通信に失敗しました。時間をおいて再度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray-100 flex justify-center items-center min-h-screen px-4 py-8">
      <PageMeta title="パスワードの再設定" noIndex />
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl text-gray-800 font-semibold mb-4 text-center">パスワードの再設定</h2>

        {isCompleted ? (
          <>
            <p className="text-sm text-gray-600 leading-relaxed mb-6">{message}</p>
            <Link
              to="/login"
              className="block text-center text-sm text-blue-600 hover:text-blue-800 hover:underline"
            >
              ログイン画面に戻る
            </Link>
          </>
        ) : (
          <>
            <p className="text-sm text-gray-600 leading-relaxed mb-6">
              店舗登録時のメールアドレスを入力してください。パスワード再設定用のリンクをお送りします。
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
                  メールアドレス
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="例: store@example.com"
                  required
                />
              </div>
              {errorMessage && <div className="text-red-500 text-[14px] mb-2">{errorMessage}</div>}
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-blue-500 hover:bg-blue-700 disabled:opacity-60 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
              >
                {isSubmitting ? '送信中...' : '再設定メールを送信'}
              </button>
            </form>
            <p className="mt-4 text-center">
              <Link
                to="/login"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                ログイン画面に戻る
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
